import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import VendorPaymentModal from "./VendorPaymentModal2025";
import { useNavigate } from "react-router-dom";
import { url } from "../link";
import Navbar from "../components/Navbar";

function Project2025() {
  const API = url;
  const nav = useNavigate();

  /* -------------------- STATES -------------------- */

  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);

  const [collages, setCollages] = useState([]);
  const [titles, setTitles] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [modalData, setModalData] = useState({});

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showViewPaymentsModal, setShowViewPaymentsModal] = useState(false);

  const [paymentData, setPaymentData] = useState({ amountpaid: "" });
  const [paymentList, setPaymentList] = useState([]);

  const [selectedPid, setSelectedPid] = useState(null);

  const [total, settotal] = useState(0);
  const [received, setreceived] = useState(0);
  const [balance, setbalance] = useState(0);
  const [vendortotal, setvendortotal] = useState(0);
  const [paid, setpaid] = useState(0);

  const [showVendorModal, setShowVendorModal] = useState(false);
  const [am, setam] = useState(0);
  const [p, setpa] = useState(0);

  /* -------------------- FETCH DATA -------------------- */

  useEffect(() => {
    fetchProjects();

    axios.get(`${API}/edusphere/collages`).then((res) => setCollages(res.data));

    axios.get(`${API}/edusphere/titles`).then((res) => setTitles(res.data));
  }, []);

  const fetchProjects = () => {
    axios.get(`${API}/edusphere/projects2025`).then((res) => {
      let t = 0,
        r = 0,
        b = 0,
        vt = 0,
        vp = 0;

      res.data.forEach((item) => {
        t += item.total_amount || 0;
        r += item.total_paid || 0;
        b += item.balance || 0;
        vt += item.vendortotal || 0;
        vp += item.paid || 0;
      });

      settotal(t);
      setreceived(r);
      setbalance(b);
      setvendortotal(vt);
      setpaid(vp);

      setProjects(res.data);
      setFilteredProjects(res.data);
    });
  };

  /* -------------------- SEARCH -------------------- */

  const handleSearch = (value) => {
    const search = value.toLowerCase();

    const filtered = projects.filter(
      (item) =>
        item.name?.toLowerCase().includes(search) ||
        item.phone_number?.toString().includes(search) ||
        item.title?.toLowerCase().includes(search) ||
        item.domain?.toLowerCase().includes(search),
    );

    setFilteredProjects(filtered);
  };

  /* -------------------- TABLE COLUMNS -------------------- */
  const columns = [
    {
      name: "PID",
      selector: (row) => row.pid,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone_number,
      sortable: true,
    },
    {
      name: "College",
      selector: (row) => row.collagename,
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Domain",
      selector: (row) => row.domain,
      sortable: true,
    },
    {
      name: "Algorithm",
      selector: (row) => row.algrm,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => row.total_amount,
      sortable: true,
    },
    {
      name: "Total Paid",
      selector: (row) => row.total_paid,
      sortable: true,
    },
    {
      name: "Balance",
      selector: (row) => row.balance,
      sortable: true,
    },
    {
      name: "Vendor",
      selector: (row) => row.vendor,
      sortable: true,
    },
    {
      name: "Vendor Total",
      selector: (row) => row.vendortotal,
      sortable: true,
    },
    {
      name: "Paid",
      selector: (row) => row.paid,
      sortable: true,
    },
    // ,
    // {
    //   name: "Status",
    //   selector: (row) => row.project_status,
    //   sortable: true,
    // },

    // {
    //   name: "Report",
    //   cell: (row) =>
    //     row.report ? (
    //       <a href={`${url}/uploads/${row.report}`} target="_blank">
    //         📄 Report
    //       </a>
    //     ) : (
    //       "-"
    //     ),
    // },

    // {
    //   name: "PPT",
    //   cell: (row) =>
    //     row.ppt ? (
    //       <a href={`${url}/uploads/${row.ppt}`} target="_blank">
    //         📊 PPT
    //       </a>
    //     ) : (
    //       "-"
    //     ),
    // }
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => {
            setSelectedRow(row);
            setShowActionModal(true);
          }}
        >
          ⚙️ Settings
        </button>
      ),
    },
  ];

  /* -------------------- PROJECT CRUD -------------------- */

  const handleChange = (e) => {
    const updated = { ...modalData, [e.target.name]: e.target.value };

    if (["total_amount", "total_paid"].includes(e.target.name)) {
      updated.balance =
        parseInt(updated.total_amount || 0) - parseInt(updated.total_paid || 0);
    }

    setModalData(updated);
  };

  const handleAdd = () => {
    setModalData({
      total_paid: 0,
      paid: 0,
      vendor: "hari",
      project_status: "ongoing",
    });
    setEditId(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setModalData(item);
    setEditId(item.pid);
    setShowModal(true);
  };

  const handleDelete = (id) => {
    axios.delete(`${API}/edusphere/projects2025/${id}`).then(fetchProjects);
  };

  /* -------------------- FILE UPLOAD -------------------- */

  const handleFileChange = (e) => {
    setModalData({ ...modalData, [e.target.name]: e.target.files[0] });
  };

  /* -------------------- SUBMIT -------------------- */

  const handleSubmit = () => {
    const formData = new FormData();

    Object.entries(modalData).forEach(([key, value]) => {
      if (value !== null) formData.append(key, value);
    });

    const method = editId ? "put" : "post";

    const endpoint = editId
      ? `${API}/edusphere/projects2025/${editId}`
      : `${API}/edusphere/projects2025`;

    axios({
      method,
      url: endpoint,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then(() => {
      setShowModal(false);
      fetchProjects();
    });
  };

  /* -------------------- PAYMENT -------------------- */

  const handleAddPayment = (pid) => {
    setSelectedPid(pid);
    setPaymentData({ amountpaid: "" });
    setShowPaymentModal(true);
  };

  const submitPayment = () => {
    axios
      .post(`${API}/edusphere/projects/${selectedPid}/payments`, paymentData)
      .then(() => {
        setShowPaymentModal(false);
        fetchProjects();
      });
  };

  const handleViewPayments = (pid) => {
    setSelectedPid(pid);

    axios.get(`${API}/edusphere/projects/${pid}/payments`).then((res) => {
      setPaymentList(res.data.payments);
      setShowViewPaymentsModal(true);
    });
  };

  const handleVendorAddPayment = (pid) => {
    setSelectedPid(pid);
    setShowVendorModal(true);
  };

  /* -------------------- UI -------------------- */
  const [showActionModal, setShowActionModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  return (
    <>
      <Navbar />

      <div className="container-fluid mt-4">
        <h3 className="fw-bold mb-3">📁 Projects</h3>
        {/* DASHBOARD CARDS */}
        <div className="row g-2 mb-3 text-center">
          <div className="col-lg-2 col-md-4 col-6">
            <div className="card shadow-sm">
              <div className="card-body p-2">
                <small>Total</small>
                <h5 className="text-primary">{total}</h5>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <div className="card shadow-sm">
              <div className="card-body p-2">
                <small>Received</small>
                <h5 className="text-success">{received}</h5>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-6">
            <div className="card shadow-sm">
              <div className="card-body p-2">
                <small>Balance</small>
                <h5 className="text-danger">{balance}</h5>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-6">
            <div className="card shadow-sm">
              <div className="card-body p-2">
                <small>Vendor Total</small>
                <h5 className="text-warning">{vendortotal}</h5>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-6">
            <div className="card shadow-sm">
              <div className="card-body p-2">
                <small>Vendor Paid</small>
                <h5 className="text-info">{paid}</h5>
              </div>
            </div>
          </div>
        </div>
        <button
          className="btn btn-primary mb-3 w-100 w-md-auto"
          onClick={handleAdd}
        >
          ➕ Add Project
        </button>
        <DataTable
          title="📁 Projects"
          columns={columns}
          data={filteredProjects}
          pagination
          responsive
          highlightOnHover
          striped
          dense
          persistTableHead
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="🔍 Search name, phone, title..."
              className="form-control"
              onChange={(e) => handleSearch(e.target.value)}
            />
          }
        />
        <VendorPaymentModal
          show={showVendorModal}
          onHide={() => setShowVendorModal(false)}
          pid={selectedPid}
          refreshPayments={fetchProjects}
          am={am}
          p={p}
        />
        {showActionModal && selectedRow && (
          <>
            {/* Dark background overlay */}
            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1040 }}
            ></div>

            <div className="modal fade show d-block" style={{ zIndex: 1050 }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">Project Actions</h5>
                    <button
                      className="btn-close btn-close-white"
                      onClick={() => setShowActionModal(false)}
                    ></button>
                  </div>

                  <div className="modal-body text-center">
                    <h5 className="mb-3">Project ID : {selectedRow.pid}</h5>

                    <div className="d-grid gap-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                          handleVendorAddPayment(selectedRow.pid);
                          setam(selectedRow.vendortotal);
                          setpa(selectedRow.paid);
                          setShowActionModal(false);
                        }}
                      >
                        🏭 Vendor Payment
                      </button>

                      <button
                        className="btn btn-outline-success"
                        onClick={() => {
                          handleAddPayment(selectedRow.pid);
                          setShowActionModal(false);
                        }}
                      >
                        💰 Add Payment
                      </button>

                      <button
                        className="btn btn-outline-info"
                        onClick={() => {
                          handleViewPayments(selectedRow.pid);
                          setShowActionModal(false);
                        }}
                      >
                        📜 View Payments
                      </button>

                      <button
                        className="btn btn-outline-warning"
                        onClick={() => {
                          handleEdit(selectedRow);
                          setShowActionModal(false);
                        }}
                      >
                        ✏️ Edit Project
                      </button>

                      <button
                        className="btn btn-outline-danger"
                        onClick={() => {
                          handleDelete(selectedRow.pid);
                          setShowActionModal(false);
                        }}
                      >
                        🗑 Delete Project
                      </button>

                      <button
                        className="btn btn-outline-dark"
                        onClick={() => {
                          nav("/addlaptop2025", { state: selectedRow.pid });
                          setShowActionModal(false);
                        }}
                      >
                        💻 Add Laptop
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {showViewPaymentsModal && (
          <>
            {/* Background overlay */}
            <div className="modal-backdrop fade show"></div>

            <div className="modal fade show d-block">
              <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                  <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">
                      💳 Payment History (Project {selectedPid})
                    </h5>

                    <button
                      className="btn-close btn-close-white"
                      onClick={() => setShowViewPaymentsModal(false)}
                    ></button>
                  </div>

                  <div className="modal-body">
                    {paymentList.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead className="table-dark">
                            <tr>
                              <th>#</th>
                              <th>Amount Paid</th>
                              <th>Balance</th>
                              <th>Date</th>
                            </tr>
                          </thead>

                          <tbody>
                            {paymentList.map((pay, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td className="text-success">
                                  ₹{pay.amountpaid}
                                </td>
                                <td className="text-danger">
                                  ₹{pay.balancetobepaid}
                                </td>
                                <td>
                                  {new Date(pay.paiddate).toLocaleString()}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="text-center text-muted">
                        No payments found
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* ADD/EDIT PROJECT MODAL */}{" "}
        {showModal && (
          <div className="modal show fade d-block">
            {" "}
            <div className="modal-dialog modal-lg">
              {" "}
              <div className="modal-content">
                {" "}
                <div className="modal-header bg-primary text-white">
                  {" "}
                  <h5 className="modal-title">
                    {" "}
                    {editId ? "Edit Project" : "Add Project"}{" "}
                  </h5>{" "}
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowModal(false)}
                  ></button>{" "}
                </div>{" "}
                <div className="modal-body">
                  {" "}
                  <input
                    name="name"
                    placeholder="Student Name"
                    value={modalData.name || ""}
                    onChange={handleChange}
                    className="form-control mb-2"
                  />{" "}
                  <input
                    name="phone_number"
                    placeholder="Phone Number"
                    value={modalData.phone_number || ""}
                    onChange={handleChange}
                    className="form-control mb-2"
                  />{" "}
                  <input
                    name="algrm"
                    placeholder="Algorithm"
                    value={modalData.algrm || ""}
                    onChange={handleChange}
                    className="form-control mb-2"
                  />{" "}
                  <input
                    name="total_amount"
                    placeholder="Total Amount"
                    value={modalData.total_amount || ""}
                    onChange={handleChange}
                    className="form-control mb-2"
                    type="number"
                  />{" "}
                  <select
                    name="vendor"
                    className="form-control mb-2"
                    value={modalData.vendor || ""}
                    onChange={handleChange}
                  >
                    {" "}
                    <option value="hari">Hari</option>{" "}
                    <option value="raj">Raj</option>{" "}
                    <option value="others">Others</option>{" "}
                  </select>{" "}
                  <input
                    name="vendortotal"
                    placeholder="Vendor Total"
                    value={modalData.vendortotal || ""}
                    onChange={handleChange}
                    className="form-control mb-2"
                    type="number"
                  />{" "}
                  <input
                    type="text"
                    name="cid"
                    className="form-control mb-2"
                    list="collegeList"
                    value={modalData.cid || ""}
                    onChange={handleChange}
                    placeholder="Select College"
                  />{" "}
                  <datalist id="collegeList">
                    {" "}
                    {collages.map((c) => (
                      <option key={c.cid} value={c.cid}>
                        {" "}
                        {c.collagename}{" "}
                      </option>
                    ))}{" "}
                  </datalist>{" "}
                  {/* Title datalist */}{" "}
                  <input
                    type="text"
                    name="project_title_id"
                    className="form-control mb-2"
                    list="titleList"
                    value={modalData.project_title_id || ""}
                    onChange={handleChange}
                    placeholder="Select Title"
                  />{" "}
                  <datalist id="titleList">
                    {" "}
                    {titles.map((t) => (
                      <option
                        key={t.project_title_id}
                        value={t.project_title_id}
                      >
                        {" "}
                        {t.title}{" "}
                      </option>
                    ))}{" "}
                  </datalist>{" "}
                  <input
                    type="file"
                    name="report"
                    className="form-control mb-2"
                    onChange={handleFileChange}
                  />{" "}
                  <input
                    type="file"
                    name="ppt"
                    className="form-control mb-2"
                    onChange={handleFileChange}
                  />{" "}
                </div>{" "}
                <div className="modal-footer">
                  {" "}
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    {" "}
                    Cancel{" "}
                  </button>{" "}
                  <button className="btn btn-success" onClick={handleSubmit}>
                    {" "}
                    {editId ? "Update Project" : "Add Project"}{" "}
                  </button>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>
        )}
        {/* ADD PAYMENT MODAL */}{" "}
        {showPaymentModal && (
          <div className="modal show fade d-block">
            {" "}
            <div className="modal-dialog">
              {" "}
              <div className="modal-content">
                {" "}
                <div className="modal-header bg-success text-white">
                  {" "}
                  <h5 className="modal-title">Add Payment</h5>{" "}
                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowPaymentModal(false)}
                  ></button>{" "}
                </div>{" "}
                <div className="modal-body">
                  {" "}
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Amount Paid"
                    value={paymentData.amountpaid}
                    onChange={(e) =>
                      setPaymentData({
                        ...paymentData,
                        amountpaid: e.target.value,
                      })
                    }
                  />{" "}
                </div>{" "}
                <div className="modal-footer">
                  {" "}
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    {" "}
                    Cancel{" "}
                  </button>{" "}
                  <button className="btn btn-success" onClick={submitPayment}>
                    {" "}
                    Save Payment{" "}
                  </button>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>
        )}
      </div>
    </>
  );
}

export default Project2025;
